import React from "react";
//#region types
import { InvoiceDimensionSectionProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { DimensionEnums } from "models/enums";
//#endregion
//#region components
import { DimensionChipSelector, FormFieldLayout, GroupSectionInline } from "components/common/wintForms";
import { StaticInfoMessage, StyledButton } from "components/common";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";

const InvoiceDimensionSection: React.FC<InvoiceDimensionSectionProps> = (props) => {
  const { invoice, currency, dimensionAmount, values, connect } = props;
  const readOnlyDimension =
    invoice.status === WintSuperkollAPIModel.InvoiceStatus.Cancelled || !!values.hasRowLevelDimensions;

  const dimensionSearchProps = connect("dimensions");

  const onChangeDimensions = () => {
    connect("hasRowLevelDimensions").setValue(false);
    if (dimensionSearchProps.setValue) {
      dimensionSearchProps.setValue([]);
    }
  };

  return (
    <GroupSectionInline
      key={`invoice-section-tags`}
      label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Tags)}
      icon={IconDefinitionConstants.WHashtag}
    >
      {values.hasRowLevelDimensions ? (
        <StaticInfoMessage gutterBottom>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.InvoiceHasRowLevelDimensions)}
        </StaticInfoMessage>
      ) : (
        <></>
      )}
      <Grid
        item
        xs={!readOnlyDimension ? 8.5 : 12}
        className={clsx(cssExports.formControlLabel, cssExports.dimensionChildFormControl)}
      >
        <DimensionChipSelector
          key={`invoice-dimension-chip-selector`}
          readonly={readOnlyDimension}
          {...dimensionSearchProps}
          layout={<FormFieldLayout className={cssExports.dimensionChild} />}
          type={DimensionEnums.DimensionCategory.Invoice}
          currency={currency}
          amount={dimensionAmount}
          hideViewAll
          enableSingleSelectionMode
        />
      </Grid>
      {values.hasRowLevelDimensions ? (
        <Grid item xs>
          <StyledButton size="xs" onClick={onChangeDimensions}>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.ChangeDimensions)}
          </StyledButton>
        </Grid>
      ) : (
        <></>
      )}
    </GroupSectionInline>
  );
};

export default InvoiceDimensionSection;
